<form [formGroup]="chargesForm" *ngIf="charges" style="margin-left: 2rem">
  <div class="flex items-center">
    <mat-checkbox style="margin-right: 5.25rem; margin-top: -22px" [checked]="solarPPAEnabled" id="solarPPAEnabled" (change)="solarPPAEnabled = !solarPPAEnabled; toggleField('solarPPA');">Solar PPA</mat-checkbox>
    <mat-form-field appearance="outline">
      <mat-label for="solarPPA" >Solar PPA ($/kWh) </mat-label>
      <input matInput type="number" class="form-control" formControlName="solarPPA" id="solarPPA" placeholder="0.00"  (change)="setDirtyForm()" />
    </mat-form-field>
  </div>

  <div class="flex items-center">
    <mat-checkbox style="margin-right: 2rem; margin-top: -22px" [checked]="contractDemandEnabled" id="contractDemandEnabled" (change)="contractDemandEnabled = !contractDemandEnabled; toggleField('contractDemand');">Contract Demand</mat-checkbox>
    <mat-form-field appearance="outline">
      <mat-label for="contractDemand">Contract Demand Setpoint (kW)</mat-label>
      <input matInput type="number" class="form-control" formControlName="contractDemand" id="contractDemand" placeholder="0.00" (change)="setDirtyForm();"/>
    </mat-form-field>
  </div>

  <div class="flex items-center justify-end">
    <button mat-flat-button color="primary" (click)="save()" [disabled]="!chargesForm.dirty" style="margin-right: 0.5rem">Save</button>
    <button mat-flat-button color="warn" (click)="cancel()" [disabled]="!chargesForm.dirty">Cancel</button>
  </div>
  <br />
</form>
